// extracted by mini-css-extract-plugin
export default {"entries-per-page":"EntriesPerPage_entries-per-page__fhX8k","select":"EntriesPerPage_select__kpQYC"};